import React from 'react'

export default function Logo({ alwaysShowText = false }) {

    return (
        <>
            <div className='logo' >
                <img src='/assets/images/logo.png' alt='Anchorize logo' />

                {(alwaysShowText) &&
                    <h5>ANCHORIZE</h5>
                }
            </div>
        </>
    )
}
